import { lazyWithReload } from "../lazy-loader/lazy-loader";
import { FeatureKey, UserRole } from "../global-types/global-types";
import { WORKFLO_NAME } from "./globalConstants";
import { Kam } from "../../pages/Kam/Kam";
import { HelpDeskLayout } from "../../pages/Crm/components/HelpDesk/HelpDeskLayout";
import { ImportLeads } from "../../pages/Crm/components/ImportLeads/ImportLeads";
import { AllLeads } from "../../pages/Crm/components/AllLeads/AllLeads";
import { TicketDetailsLayout } from "../../pages/Crm/components/HelpDesk/components/TicketDetails/TicketDetailsLayout";
import { CreateTicket } from "../../pages/Crm/components/HelpDesk/components/CreateTicket/CreateTicket";
import DealsLayout from "../../pages/Crm/components/Deals/DealsLayout";
import InboxLayout from "../../pages/Crm/components/Inbox/InboxLayout";

const ViewingsLayout = lazyWithReload(
  () => import("../../pages/Crm/components/Viewings/ViewingsLayout")
);

const TasksFollowUpsLayout = lazyWithReload(
  () => import("../../pages/Crm/components/TasksFollowUps/TasksFollowUpsLayout")
);

const AllJourneys = lazyWithReload(
  () => import("../../pages/DynamicTriggerEngine/AllJourneys/AllJourneys")
);

const AnalyticsV2 = lazyWithReload(
  () => import("../../pages/Analytics/LegacyAnalytics/LegacyAnalytics")
);
const VerbaiqAnalyticsGate = lazyWithReload(
  () => import("../../pages/Analytics/VerbaiqAnalyticsGate")
);
const LeadDetails = lazyWithReload(
  () => import("../../pages/Crm/components/LeadDetails/LeadDetails")
);
const LeadList = lazyWithReload(
  () => import("../../pages/Crm/components/KanbanGrid/LeadList")
);
const DealDetails = lazyWithReload(
  () =>
    import("../../pages/Crm/components/Deals/components/DealDetails/DealDetails")
);

const NowFormsLayout = lazyWithReload(
  () => import("../../pages/Crm/components/NowForms/NowFormsLayout")
);
const PropertyManagementSystemV2 = lazyWithReload(
  () => import("../../pages/PropertyManagementSystem/PropertyManagementSystem")
);
const PMSDetailV2 = lazyWithReload(
  () => import("../../pages/PropertyManagementSystem/PMSDetail")
);
const Playground = lazyWithReload(
  () => import("../../pages/Playground/Playground")
);
const PlaygroundV2 = lazyWithReload(
  () => import("../../pages/PlaygroundV2/PlaygroundV2")
);
const WorkfloV2 = lazyWithReload(
  () => import("../../pages/WorkfloV2/WorkfloV2")
);
const PropertyManagementV2 = lazyWithReload(
  () => import("../../pages/PropertyManagementV2/PropertyManagementV2")
);
const BillingV2 = lazyWithReload(() => import("../../pages/Billing/Billing"));
const UserManual = lazyWithReload(
  () => import("../../pages/UserManual/UserManual")
);
const TicketManagementV2 = lazyWithReload(
  () => import("../../pages/TicketManagement/TicketManagement")
);
const AlertsV2 = lazyWithReload(() => import("../../pages/Alerts/Alerts"));
const Communications = lazyWithReload(
  () => import("../../pages/Communications/Communications")
);
const CommunicationsV2 = lazyWithReload(
  () => import("../../pages/CommunicationsV2/CommunicationsV2")
);
const CreateCampaign = lazyWithReload(
  () => import("../../pages/Campaigns/CreateEditCampaign")
);
const Campaigns = lazyWithReload(
  () => import("../../pages/Campaigns/Campaigns")
);
const ViewCampaign = lazyWithReload(
  () => import("../../pages/Campaigns/ViewCampaign/ViewCampaign")
);
const UserManagementLayout = lazyWithReload(
  () => import("../../pages/UserManagement/UserManagementLayout")
);
const UserManagementV2 = lazyWithReload(
  () => import("../../pages/UserManagementV2/UserManagementV2")
);
const WebSyncStatus = lazyWithReload(
  () =>
    import("../../pages/Playground/components/KnowledgeBase/components/Website/WebSyncStatus")
);
const ScrapeUrlDetails = lazyWithReload(
  () =>
    import("../../pages/Playground/components/KnowledgeBase/components/Website/ScrapeUrlDetails")
);

const CommunicationAnalytics = lazyWithReload(
  () =>
    import("../../pages/Communications/components/Analytics/CommunicationAnalytics")
);
const SignIn = lazyWithReload(() => import("../../pages/Auth/Sign"));
const ForgotPassword = lazyWithReload(
  () => import("../../pages/Auth/ForgotPassword")
);
const SetPassword = lazyWithReload(
  () => import("../../pages/Auth/SetPassword")
);
const ResetPassword = lazyWithReload(
  () => import("../../pages/Auth/ResetPassword")
);
const Unsubscribe = lazyWithReload(
  () => import("../../pages/Unsubscribe/Unsubscribe")
);
const SettingsV2 = lazyWithReload(
  () => import("../../pages/Settings/Settings")
);
// Configurability now lives under Settings; lazy import disabled.
// const Configurability = lazyWithReload(
//   () => import("../../pages/Configurability/Configurability")
// );
const VfCopilot = lazyWithReload(
  () => import("../../pages/VfCopilot/VfCopilot")
);
export interface RouteConfig {
  id?: string;
  path: string;
  component: React.ComponentType;
  allowedRoles: UserRole[];
  layout?: "sidebar" | "standalone";
  requiresFeature?: FeatureKey;
  fallbackComponent?: React.ComponentType;
}

export interface FeatureConfig {
  key: FeatureKey;
  name: string;
  isEnabled: boolean;
  allowedRoles: UserRole[];
  routes: RouteConfig[];
}

export const authRoutes: RouteConfig[] = [
  {
    path: "/sign-in",
    component: SignIn,
    allowedRoles: [
      "vf-admin",
      "vf-editor",
      "vf-viewer",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
    ],
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    allowedRoles: [
      "vf-admin",
      "vf-editor",
      "vf-viewer",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
    ],
  },
  {
    path: "/forgot-password/reset",
    component: ResetPassword,
    allowedRoles: [
      "vf-admin",
      "vf-editor",
      "vf-viewer",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
    ],
  },
  {
    path: "/set-password",
    component: SetPassword,
    allowedRoles: [
      "vf-admin",
      "vf-editor",
      "vf-viewer",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
    ],
  },
  {
    path: "/unsubscribe",
    component: Unsubscribe,
    allowedRoles: [
      "vf-admin",
      "vf-editor",
      "vf-viewer",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
    ],
  },
  // {
  //   path: "/dashboard/disable-account",
  //   component: DisableAccount,
  //   allowedRoles: [
  //     "vf-admin",
  //     "vf-editor",
  //     "vf-viewer",
  //     "superadmin",
  //     "admin",
  //     "editor",
  //     "commentor",
  //     "viewer",
  //   ],
  // },
];

export const features: Record<FeatureKey, FeatureConfig> = {
  analytics: {
    key: "analytics",
    name: "Analytics",
    isEnabled: true,
    allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
    routes: [
      {
        path: "/dashboard/analytics",
        component: AnalyticsV2,
        allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
      },
      {
        id: "verbaiq_analytics",
        path: "/dashboard/verbaiq-analytics",
        component: VerbaiqAnalyticsGate,
        allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
      },
    ],
  },
  dte: {
    key: "dte",
    name: "Dynamic Trigger Engine",
    isEnabled: true,
    allowedRoles: ["vf-admin", "superadmin", "admin", "editor", "vf-viewer"],
    routes: [
      {
        path: "/dashboard/dte/journeys/all",
        component: AllJourneys,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/dte/journeys/create",
        component: AllJourneys,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/dte/journeys/:journeyId/:view",
        component: AllJourneys,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/dte/campaigns",
        component: AllJourneys,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/dte/cohorts",
        component: AllJourneys,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/dte/settings",
        component: AllJourneys,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "vf-viewer",
        ],
      },
    ],
  },
  crm: {
    key: "crm",
    name: "CRM",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "superadmin",
      "admin",
      "commentor",
      "editor",
      "viewer",
      "vf-viewer",
    ],

    routes: [
      {
        path: "/dashboard/crm/leasing",
        component: LeadList,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/all-forms",
        component: NowFormsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/create-form",
        component: NowFormsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/logs",
        component: NowFormsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/form-submission-logs",
        component: NowFormsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/form-analytics",
        component: NowFormsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/follow-ups",
        component: TasksFollowUpsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/:leadId",
        component: LeadDetails,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "commentor",
          "editor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/helpdesk/:tabId",
        component: HelpDeskLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/helpdesk/:tabId/:ticketId",
        component: TicketDetailsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/helpdesk/create-ticket",
        component: CreateTicket,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/helpdesk/edit-ticket/:ticketId",
        component: CreateTicket,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/all-leads",
        component: AllLeads,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/import-leads",
        component: ImportLeads,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/bookings",
        component: DealsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/bookings/:dealId",
        component: DealDetails,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/inbox",
        component: InboxLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/crm/viewings",
        component: ViewingsLayout,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
    ],
  },

  pms: {
    key: "pms",
    name: "Property Management System",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
      "vf-viewer",
    ],
    routes: [
      {
        path: "/dashboard/pms",
        component: PropertyManagementSystemV2,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/pms/:tabId",
        component: PropertyManagementSystemV2,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/property/:managerName/:propCode",
        component: PMSDetailV2,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        // Distinct URL from the legacy "/dashboard/pms" / "/dashboard/pms/:tabId"
        // routes above — the legacy Property Management screens stay completely
        // untouched. Still under the "pms" feature so it reuses the existing
        // pms_config gating rather than wiring up a whole new feature key.
        path: "/dashboard/pms-v2/:tab?",
        component: PropertyManagementV2,
        layout: "standalone",
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        // The V2 property detail screen — a distinct, addressable URL (not
        // local-only state) so it's bookmarkable and the browser back button
        // works, mirroring the legacy "/dashboard/property/:managerName/:propCode"
        // route below. Points at the same PropertyManagementV2 component as the
        // list route above: it reads `propertyId` via useParams and renders the
        // detail view instead of the grid/list when present (see PropertyDetailV2).
        path: "/dashboard/pms-v2/property/:propertyId",
        component: PropertyManagementV2,
        layout: "standalone",
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
    ],
  },

  communication: {
    key: "communication",
    name: "Communication",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "vf-editor",
      "vf-viewer",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
    ],
    routes: [
      // {
      //   path: "/dashboard/communication/settings",
      //   component: CommunicationWrapper,
      //   allowedRoles: [
      //     "vf-admin",
      //     "superadmin",
      //     "admin",
      //     "editor",
      //     "commentor",
      //     "viewer",
      //     "vf-viewer",
      //   ],
      // },
      // {
      //   path: "/dashboard/communication/:page/:modality/:leadId?",
      //   component: CommunicationWrapper,
      //   allowedRoles: [
      //     "vf-admin",
      //     "superadmin",
      //     "admin",
      //     "editor",
      //     "commentor",
      //     "viewer",
      //     "vf-viewer",
      //   ],
      // },
      {
        path: "/dashboard/communications-v2/inbox",
        component: CommunicationsV2,
        layout: "standalone",
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbachat",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbachat/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbacall",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbacall/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbamail",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbamail/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbamessenger",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbamessenger/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbasms",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/verbasms/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/fbmessenger",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/fbmessenger/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/wechat",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/wechat/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/instagram",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/communications/inbox/instagram/:leadId",
        component: Communications,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
      {
        path: "/dashboard/communications/analytics/:modality",
        component: CommunicationAnalytics,
        allowedRoles: [
          "vf-admin",
          "vf-viewer",
          "vf-editor",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
        ],
      },
    ],
  },

  campaigns: {
    key: "campaigns",
    name: `${WORKFLO_NAME.plural}`,
    isEnabled: true,
    allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
    routes: [
      {
        path: "/dashboard/workflo-v2/:tab?",
        component: WorkfloV2,
        layout: "standalone",
        allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
      },
      {
        path: "/dashboard/campaigns/create",
        component: CreateCampaign,
        allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
      },
      {
        path: "/dashboard/campaigns/manage/:page",
        component: Campaigns,
        allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
      },
      {
        path: "/dashboard/campaigns/:campaignId/:tab/:modality?/:leadId?",
        component: ViewCampaign,
        allowedRoles: ["vf-admin", "superadmin", "admin", "editor"],
      },
    ],
  },

  playground: {
    key: "playground",
    name: "Playground",
    isEnabled: true,
    allowedRoles: ["vf-admin", "superadmin", "admin"],
    routes: [
      {
        path: "/dashboard/playground-v2/:tab?",
        component: PlaygroundV2,
        layout: "standalone",
        allowedRoles: ["vf-admin", "superadmin", "admin"],
      },
      {
        path: "/dashboard/playground",
        component: Playground,
        allowedRoles: ["vf-admin", "superadmin", "admin"],
      },
      {
        path: "/dashboard/playground/:tab?",
        component: Playground,
        allowedRoles: ["vf-admin", "superadmin", "admin"],
      },
      {
        path: "/dashboard/playground/:tab?/web-sync-status/:directoryId?",
        component: WebSyncStatus,
        allowedRoles: ["vf-admin", "superadmin", "admin"],
      },
      {
        path: "/dashboard/playground/:tab?/scrape-contents/:directoryId?",
        component: ScrapeUrlDetails,
        allowedRoles: ["vf-admin", "superadmin", "admin"],
      },
    ],
  },

  user_management: {
    key: "user_management",
    name: "User Management",
    isEnabled: true,
    allowedRoles: ["vf-admin", "superadmin", "admin"],
    routes: [
      {
        path: "/dashboard/user-management/:tabId",
        component: UserManagementLayout,
        allowedRoles: ["vf-admin", "superadmin", "admin"],
      },
      {
        // Distinct URL from the legacy "/dashboard/user-management/:tabId"
        // route above — the legacy screen stays untouched. Still under the
        // "user_management" feature so it reuses the existing gating,
        // mirroring the pms-v2 pattern above.
        path: "/dashboard/user-management-v2/:tab?",
        component: UserManagementV2,
        layout: "standalone",
        allowedRoles: ["vf-admin", "superadmin", "admin"],
      },
    ],
  },

  settings: {
    key: "settings",
    name: "Settings",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "superadmin",
      "admin",
      // "superadmin",
      // "admin",
      // "editor",
      // "commentor",
      // "viewer",
      // "vf-viewer",
    ],
    routes: [
      {
        path: "/dashboard/settings",
        component: SettingsV2,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          // "superadmin",
          // "admin",
          // "editor",
          // "commentor",
          // "viewer",
          // "vf-viewer",
        ],
      },
      {
        path: "/dashboard/settings/:tabId",
        component: SettingsV2,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          // "superadmin",
          // "admin",
          // "editor",
          // "commentor",
          // "viewer",
          // "vf-viewer",
        ],
      },
    ],
  },

  configurability: {
    key: "configurability",
    name: "Configurability",
    isEnabled: true,
    allowedRoles: ["vf-admin", "superadmin", "admin"],
    // Configurability now lives under Settings; routes disabled.
    routes: [
      // {
      //   path: "/dashboard/configurability",
      //   component: Configurability,
      //   allowedRoles: ["vf-admin", "superadmin", "admin"],
      // },
      // {
      //   path: "/dashboard/configurability/:tabId",
      //   component: Configurability,
      //   allowedRoles: ["vf-admin", "superadmin", "admin"],
      // },
    ],
  },

  billing: {
    key: "billing",
    name: "Billing",
    isEnabled: true,
    allowedRoles: ["vf-admin", "superadmin"],
    routes: [
      {
        path: "/dashboard/billing",
        component: BillingV2,
        allowedRoles: ["vf-admin", "superadmin"],
      },
    ],
  },

  vf_copilot: {
    key: "vf_copilot",
    name: "VF Copilot",
    isEnabled: true,
    allowedRoles: ["vf-admin"],
    routes: [
      {
        path: "/dashboard/verbaIQ",
        component: VfCopilot,
        allowedRoles: ["vf-admin"],
      },
    ],
  },

  user_manual: {
    key: "user_manual",
    name: "User Manual",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
      "vf-viewer",
    ],
    routes: [
      {
        path: "/dashboard/user-manual",
        component: UserManual,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
    ],
  },

  ticket_management: {
    key: "ticket_management",
    name: "Ticket Management",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
      "vf-viewer",
    ],
    routes: [
      {
        path: "/dashboard/ticket-management",
        component: TicketManagementV2,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
    ],
  },

  kam: {
    key: "kam",
    name: "Key Account Manager",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
      "vf-viewer",
    ],
    routes: [
      {
        path: "/dashboard/kam",
        component: Kam,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
    ],
  },

  alerts: {
    key: "alerts",
    name: "Alerts",
    isEnabled: true,
    allowedRoles: [
      "vf-admin",
      "superadmin",
      "admin",
      "editor",
      "commentor",
      "viewer",
      "vf-viewer",
    ],
    routes: [
      {
        path: "/dashboard/alerts",
        component: AlertsV2,
        allowedRoles: [
          "vf-admin",
          "superadmin",
          "admin",
          "editor",
          "commentor",
          "viewer",
          "vf-viewer",
        ],
      },
    ],
  },
};
